module.exports = __webpack_public_path__ + "img/topic-necklace.26aa7aa9.jpg";